module.exports = __webpack_public_path__ + "img/marketing.efd6dee3.png";